/* eslint-disable global-require */
module.exports = ['lots.search.form.sold.m1'];
